'use strict';

import {reductionModel} from "../../models/reductionmodel.js";

export class ProjectReductionListCtrl
{
	reductions = [];

	constructor($scope, $filter, $mdDialog, jsDataService){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.setReductions(this.jsDataService.get('reductions', {}));
	}

	setReductions(reductions){
		this.reductions = [];
		for(let recoveryData of reductions){
			this.reductions.push(new reductionModel(recoveryData, this.$filter, this.jsDataService));
		}
	}

	addReduction(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', this.addReductionCtrl],
			controllerAs: 'ctrla',
			templateUrl: 'projects/new_project_reduction_dialog.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
			}
		}).then((results) => {
			if(this.jsDataService.get('cfgCreateUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgCreateUrl'),
					method: 'POST',
					data: {
						apply_reduction_to_participants: results.apply_reduction_to_participants
					}
				}).then((response) => {
				}, () => {});
			}
		}, (results) => {
		});
	}

	addReductionCtrl($scope, $mdDialog, jsDataService){
		$scope.apply_reduction_to_participants = false;
		console.log($scope.apply_reduction_to_participants )
		$scope.close = function() {
			$mdDialog.cancel();
		};
		$scope.save = function() {
			let outp = {
				apply_reduction_to_participants: $scope.apply_reduction_to_participants
			};
			$mdDialog.hide(outp);
		};
	}


	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}

}


